import { createSlice } from '@reduxjs/toolkit'

import { fetchUserFeatures } from 'features/billing/actions/fetch_user_features'

const initialState = {
  features: []
}

const userFeaturesSlice = createSlice({
  name: 'userFeatures',
  initialState,
  extraReducers: (builder) => {
    builder.addCase(fetchUserFeatures.fulfilled, (state, action) => {
      state.features = action.payload.userFeatures || []
    })
  }
})

export const {
  reducer,
} = userFeaturesSlice
